function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 128,
  height: 40,
  rx: 4,
  fill: "#E8EEF4"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M54.4 25H61.47V23.53H55.94V20.66H60.21V19.19H55.94V16.67H61.33V15.2H54.4V25ZM62.5255 25H64.1355L65.8855 22.55L67.6355 25H69.2455L66.7255 21.5L69.0355 18.28H67.4255L65.8855 20.45L64.3455 18.28H62.7355L65.0455 21.5L62.5255 25ZM70.6455 27.94H72.0455V24.02C72.1855 24.23 72.3675 24.412 72.5915 24.58C72.9695 24.86 73.5295 25.14 74.3555 25.14C76.0355 25.14 77.5055 23.67 77.5055 21.64C77.5055 19.61 76.0355 18.14 74.3555 18.14C73.5295 18.14 72.9695 18.42 72.5915 18.7C72.3675 18.868 72.1855 19.05 72.0455 19.26V18.28H70.6455V27.94ZM74.0755 23.81C72.9555 23.81 72.0455 22.914 72.0455 21.64C72.0455 20.366 72.9555 19.47 74.0755 19.47C75.1955 19.47 76.1055 20.366 76.1055 21.64C76.1055 22.914 75.1955 23.81 74.0755 23.81ZM78.9 21.64C78.9 23.6 80.44 25.14 82.4 25.14C84.36 25.14 85.9 23.6 85.9 21.64C85.9 19.68 84.36 18.14 82.4 18.14C80.44 18.14 78.9 19.68 78.9 21.64ZM82.4 23.81C81.21 23.81 80.3 22.914 80.3 21.64C80.3 20.366 81.21 19.47 82.4 19.47C83.59 19.47 84.5 20.366 84.5 21.64C84.5 22.914 83.59 23.81 82.4 23.81ZM87.7211 25H89.1211V21.57C89.1211 20.38 89.9751 19.54 90.9411 19.54C91.0951 19.54 91.2071 19.568 91.3191 19.582L91.5011 19.61V18.14H91.1511C90.4791 18.14 89.9751 18.406 89.6391 18.672C89.4431 18.826 89.2751 19.008 89.1211 19.19V18.28H87.7211V25ZM93.746 22.9C93.746 24.37 94.502 25.14 95.846 25.14C96.168 25.14 96.42 25.098 96.602 25.042L96.896 24.93V23.6L96.672 23.712C96.518 23.768 96.336 23.81 96.126 23.81C95.468 23.81 95.146 23.46 95.146 22.76V19.61H96.686V18.28H95.146V16.04H93.886V17.51C93.886 18.07 93.69 18.28 93.256 18.28H92.486V19.61H93.746V22.9Z",
  fill: "#212D43"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M114.443 19.7494C114.443 19.9404 114.37 20.1324 114.224 20.2784L110.754 23.7654C110.613 23.9064 110.422 23.9854 110.222 23.9854C110.023 23.9854 109.832 23.9064 109.691 23.7654L106.219 20.2784C105.927 19.9854 105.927 19.5114 106.221 19.2184C106.515 18.9264 106.99 18.9274 107.282 19.2204L110.222 22.1734L113.162 19.2204C113.454 18.9274 113.928 18.9264 114.222 19.2184C114.37 19.3644 114.443 19.5574 114.443 19.7494Z",
  fill: "#212D43"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.5,
  x: 40,
  y: 8,
  width: 1,
  height: 24,
  fill: "#3558C7",
  fillOpacity: 0.4
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  opacity: 0.4,
  d: "M24.6655 16.5977C26.5037 16.5977 28 18.1425 28 20.0412V23.8155C28 25.7095 26.5075 27.2505 24.673 27.2505H16.336C14.497 27.2505 13 25.7064 13 23.8077L13 20.0335C13 18.1394 14.4932 16.5977 16.3285 16.5977H17.0335L24.6655 16.5977Z",
  fill: "#212121"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M20.9095 23.153L23.0912 20.9271C23.3162 20.6971 23.3162 20.3268 23.0897 20.0975C22.8632 19.869 22.498 19.8698 22.273 20.0991L21.0782 21.3179V13.5866C21.0782 13.2628 20.8195 13 20.5 13C20.1812 13 19.9232 13.2628 19.9232 13.5866V21.3179L18.7277 20.0991C18.5027 19.8698 18.1375 19.869 17.911 20.0975C17.7977 20.2126 17.7407 20.3626 17.7407 20.5135C17.7407 20.6628 17.7977 20.8128 17.9095 20.9271L20.0912 23.153C20.2 23.2635 20.347 23.326 20.5 23.326C20.6537 23.326 20.8007 23.2635 20.9095 23.153Z",
  fill: "#212121"
});

function SvgExport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 40,
    viewBox: "0 0 128 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/Export.0a1a85e4.svg";
export { ForwardRef as ReactComponent };